// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

export const fetchContactById = contactId => fetchWrapper(`/contacts/${contactId}`)

export const fetchContactsByQuery = q => fetchWrapper(`/contacts${q}`)
